import React, { useEffect } from 'react';
import {
  Breadcrumbs, LinearProgress, Typography,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import PageLayout from '../../PageLayout';
import ProviderForm from '../ProviderForm';
import { providerActions } from '../../../redux/actions';
import { providersTexts } from '../../../constants';

const EditProviderPage = ({ routeParams: { id: providerId } }) => {
  const dispatch = useDispatch();
  const provider = useSelector((state) => state.provider.data);

  useEffect(() => {
    dispatch(providerActions.get(providerId));
  }, [dispatch, providerId]);

  function EditProviderBreadcrumbs() {
    const providerLink = `/providers/${providerId}`;

    return (
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link color="inherit" to="/providers" style={{ textDecoration: 'none' }}>
          <Typography variant="caption" color="textPrimary" style={{ fontWeight: 400, fontSize: 11 }}>{providersTexts.providers}</Typography>
        </Link>
        <Link color="inherit" to={providerLink} style={{ textDecoration: 'none' }}>
          <Typography variant="caption" color="textPrimary" style={{ fontWeight: 400, fontSize: 11 }}>{provider.name}</Typography>
        </Link>
        <Typography variant="caption" color="textPrimary" style={{ fontWeight: 700, fontSize: 11 }}>{providersTexts.modifyProvider}</Typography>
      </Breadcrumbs>
    );
  }

  function EditProviderLoadingBreadcrumbs() {
    return (
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link color="inherit" to="/providers" style={{ textDecoration: 'none' }}>
          <Typography variant="caption" color="textPrimary" style={{ fontWeight: 400, fontSize: 11 }}>{providersTexts.providers}</Typography>
        </Link>
        <Typography variant="caption" color="textPrimary" style={{ fontWeight: 700, fontSize: 11 }}>{providersTexts.modifyProvider}</Typography>
      </Breadcrumbs>
    );
  }

  return (
    <>
      {provider
        ? (
          <PageLayout
            title={provider.name}
            breadCrumbs={<EditProviderBreadcrumbs />}
          >
            <ProviderForm edit data={provider} />
          </PageLayout>
        )
        : (
          <PageLayout
            title={providersTexts.modifyProvider}
            breadCrumbs={<EditProviderLoadingBreadcrumbs />}
          >
            <LinearProgress />
          </PageLayout>
        )}
    </>

  );
};

EditProviderPage.propTypes = {
  routeParams: PropTypes.shape(),
};

EditProviderPage.defaultProps = {
  routeParams: {},
};

export default EditProviderPage;
